import React from 'react';
type ProgressBarVariant = 'primary' | 'secondary' | 'accent' | 'warning' | 'success';
type ProgressBarProps = {
  value: number;
  max?: number;
  variant?: ProgressBarVariant;
  showLabel?: boolean;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
};
export const ProgressBar: React.FC<ProgressBarProps> = ({
  value,
  max = 100,
  variant = 'primary',
  showLabel = false,
  size = 'md',
  className = ''
}) => {
  const percentage = Math.min(Math.max(0, value / max * 100), 100);
  const variantStyles = {
    primary: 'bg-primary',
    secondary: 'bg-secondary',
    accent: 'bg-accent',
    warning: 'bg-warning',
    success: 'bg-success'
  };
  const sizeStyles = {
    sm: 'h-1',
    md: 'h-2',
    lg: 'h-3'
  };
  return <div className={`w-full ${className}`} data-id="element-313">
      <div className="w-full bg-gray-100 rounded-full overflow-hidden" data-id="element-314">
        <div className={`${variantStyles[variant]} ${sizeStyles[size]} rounded-full transition-all duration-300 ease-in-out`} style={{
        width: `${percentage}%`
      }} data-id="element-315"></div>
      </div>
      {showLabel && <div className="mt-1.5 text-xs text-gray-500 font-medium flex justify-between" data-id="element-316">
          <span data-id="element-317">{value}</span>
          <span data-id="element-318">{max}</span>
        </div>}
    </div>;
};